import React, { useState } from "react";
import moment from "moment-timezone";
import "../../shared/styles/shared-styles.css";
import "./extend-assignment.css";
import "../edit-shift-modal/EditTime";
import EditTime from "../edit-shift-modal/EditTime";
import DaysOfWeek from "../../shared/components/days-of-week/DaysOfWeek";
import {
  getAssignmentDate,
  getAssignmentMinEndDate,
  getAssignmentTime,
  getAssignmentWorkingDays,
  getJobDate,
} from "./utils";

const ExtendAssignmentModal = (props) => {
  const {
    onClose,
    onExtendAssignment,
    timezone,
    userJobs,
  } = props;
  const [selectedJob, setSelectedJob] = useState(userJobs[0]);
  const [startDate, setStartDate] = useState(getAssignmentDate(selectedJob.start_date_time, timezone));
  // Default value, so we can check if something was changed in the field
  // We should keep it in through the useSate because job can be changed in select component,
  // and we should react on that
  const [shiftEndDate, setShiftEndDate] = useState(getAssignmentDate(selectedJob.end_date_time, timezone));
  const [endDate, setEndDate] = useState(getAssignmentDate(selectedJob.end_date_time, timezone));
  const [startTime, setStartTime] = useState(getAssignmentTime(selectedJob.start_date_time, timezone));
  const [endTime, setEndTime] = useState(getAssignmentTime(selectedJob.end_date_time, timezone));
  const [workingDays, setWorkingDays] = useState(getAssignmentWorkingDays(selectedJob));
  const [minEndDate, setMinEndDate] = useState(getAssignmentMinEndDate(startDate, timezone));

  const onChangeJob = e => {
    const { value } = e.target;
    const newSelectedJob = userJobs.find(job => job.jobId === +value);
    // Update Form values if job changed
    setSelectedJob(newSelectedJob);
    setStartTime(getAssignmentTime(newSelectedJob.start_date_time, timezone));
    setMinEndDate(getAssignmentMinEndDate(newSelectedJob.start_date_time, timezone));
    setEndTime(getAssignmentTime(newSelectedJob.end_date_time, timezone));
    setWorkingDays(getAssignmentWorkingDays(newSelectedJob));
    setStartDate(getAssignmentDate(newSelectedJob.start_date_time, timezone));
    setShiftEndDate(getAssignmentDate(newSelectedJob.end_date_time, timezone));
    setEndDate(getAssignmentDate(newSelectedJob.end_date_time, timezone));
  };

  const onChangeEndDate = e => {
    const newEndDate = e.target.value;
    const isAfterMinEndDate = moment.tz(newEndDate, timezone).isSameOrAfter(moment.tz(minEndDate, timezone));
    const isSame = moment.tz(newEndDate, timezone).isSame(moment.tz(startDate, timezone));
    if (isAfterMinEndDate || isSame) {
      setEndDate(newEndDate);
    }
  }

  const confirmButtonDisabled = shiftEndDate === endDate;

  return (
    <div className="shift-modal-container">
      <div className="modal-body edit-shifts-modal-body">
        <h2 className="header-styles">Edit shifts</h2>
        {/* Request */}
        <div className="request-container">
          <span className="form-title">Select Job Request</span>
          <select
            className="edit-assignments-select extend-assignment-select"
            name="selected-request"
            onChange={onChangeJob}
            required
          >
            {
              userJobs.map(job => {
                const date = getJobDate(job, timezone);
                return (
                  <option value={job.jobId} key={job.jobId}>
                    Request {job.jobId} ({date})
                  </option>
                );
              })
            }
          </select>
        </div>

        {/* Start/End date */}
        <div className="field-container date-container">
          <div className="date-input-container input-margin-right">
            <span className="form-title">Start date</span>
            <input
              className="date-input"
              disabled
              type="date"
              value={startDate}
            />
          </div>
          <div className="date-input-container">
            <span className="form-title">End date</span>
            <input
              className="date-input"
              min={minEndDate}
              type="date"
              value={endDate}
              onChange={onChangeEndDate}
            />
          </div>
        </div>

        {/* Start/End time */}
        <div className="field-container assignment-time-container">
          <EditTime
            disabled={true}
            startTime={startTime}
            endTime={endTime}
          />
        </div>
        {/* Work days */}
        <div className="field-container">
          <span className="form-title" >Work days</span>
          <DaysOfWeek workingDays={workingDays} />
        </div>
        {/* Supervisor */}
        <div className="field-container">
          <span className="form-title">Supervisor</span>
          <select
            className="edit-assignments-select extend-assignment-select"
            disabled
            name="selected-request"
          >
            <option value={selectedJob.supervisor}>
              {selectedJob.supervisor}
            </option>
          </select>
        </div>
        {/* Wage */}
        <div className="field-container wage-container">
          <span className="form-title">Wage</span>
          <span className="wage-info">${selectedJob.wage.toFixed(2)}</span>
        </div>

        <div className="modal-buttons-container">
          <button
            className="modal-button modal-cancel-button"
            onClick={onClose}
            data-pendo-key="roster-week-view-update-modal-cancel-button"
          >
            Cancel
          </button>
          <button
            disabled={confirmButtonDisabled}
            className={`modal-button modal-confirm-button ${confirmButtonDisabled && 'confirm-disabled'}`}
            onClick={() => onExtendAssignment({ job: selectedJob, endDate })}
            data-pendo-key="roster-week-view-update-modal-update-button"
          >
            Update shifts
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExtendAssignmentModal;
